<template>
    <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <rect x="3" y="5" width="14" height="14" rx="1"></rect>
        <path d="M17 9l4-2v10l-4-2z"></path>
    </svg>
</template>
